import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { DayPicker } from 'react-day-picker';

import { VFlex } from '../VFlex';
import { VTextButton } from '../VTextButton';
import type { DATEPICKER_MODE } from './constant';
import { DAYPICKER_BASE_PROPS } from './constant';
import useVDatePickerContext from './hook';
import style from './style';
import type { VDateRangePickerContentProps } from './type';
import { isSameDate } from './util';

const VDateRangePickerContent = ({
  onClose,
  onSelect,
}: VDateRangePickerContentProps) => {
  const { value } = useVDatePickerContext<DATEPICKER_MODE.RANGE>();
  const [innerValue, setInnerValue] = useState(
    value.map(v => dayjs(v).toDate()),
  );
  const [month, setMonth] = useState(innerValue[innerValue.length - 1]);

  useEffect(() => {
    if (
      value == null ||
      value.length === 0 ||
      value.length !== innerValue.length ||
      (isSameDate(value[0], innerValue[0]) &&
        isSameDate(value[1] ?? '', innerValue[1]))
    )
      return;
    setInnerValue(value.map(v => dayjs(v).toDate()));
    setMonth(dayjs(value[value.length - 1]).toDate());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return (
    <>
      <DayPicker
        {...DAYPICKER_BASE_PROPS}
        components={{
          ...DAYPICKER_BASE_PROPS.components,
          DayButton(props) {
            const {
              day: { date, outside },
              modifiers: { range_end, range_middle, range_start },
            } = props;

            return (
              <button
                {...props}
                className={style.vDatePickerDayButton({
                  isToday: isSameDate(date, new Date()),
                  outside,
                  rangeEnd: range_end,
                  rangeMiddle: range_middle,
                  rangeStart: range_start,
                })}
              />
            );
          },
        }}
        mode="range"
        month={month}
        // startMonth={new Date('2025-01-01T00:00:00+0900')}
        required
        selected={{
          from: innerValue[0],
          to: innerValue[1],
        }}
        onMonthChange={setMonth}
        onSelect={e => {
          const from = e.from!;
          const to = e.to ?? from;

          setInnerValue([from, to]);
        }}
      />
      <VFlex justify="between" className="w-full px-4 pb-4">
        <VTextButton onClick={onClose}>Cancel</VTextButton>
        <VTextButton onClick={() => onSelect(innerValue as [Date, Date])}>
          OK
        </VTextButton>
      </VFlex>
    </>
  );
};

export default VDateRangePickerContent;
